const ROUTES = {
  HOME: "/",
  PROJECT: "/projects",
  PROWESS: "/skils",
};

export default ROUTES;
